import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDeleteUserAccount, useGetUserInfoMe } from "@src/entities/user";
import { InputField } from "@src/shared/ui/InputField";
import { Button } from "@mui/material";
import { backButtonStyles, saveBtnStyles } from "../constants";
import { yupResolver } from "@hookform/resolvers/yup";
import { accountDeletionStep1Schema, RESEND_TIMEOUT } from "./constants";
import { userАccountСhangesStore } from "@src/entities/user/model/store/userАccountСhangesStore";
import { ArrowBack } from "@mui/icons-material";

import styles from "./AccountDeletionStep1.module.scss";

interface AccountDeletionStep1Props {
  email: string;
}

interface Props {
  setStep: (step: number) => void;
  setIsDisabledBtn: (falg: boolean) => void;
  setRemainingSeconds: (value: number) => void;
  remainingSeconds: number;
  isDisabledBtn: boolean;
}

export const AccountDeletionStep1 = ({
  setStep,
  setIsDisabledBtn,
  setRemainingSeconds,
  isDisabledBtn,
  remainingSeconds,
}: Props) => {
  const { data: userInfo } = useGetUserInfoMe();
  const { mutate: deleteUserAccount } = useDeleteUserAccount();
  const setInfo = userАccountСhangesStore((state) => state.setInfo);

  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<AccountDeletionStep1Props>({
    defaultValues: {
      email: userInfo?.data?.email || "",
    },
    resolver: yupResolver(accountDeletionStep1Schema) as any,
  });

  const onSubmit = (data: AccountDeletionStep1Props) => {
    const params = { login: data.email };
    deleteUserAccount(params, {
      onSuccess: () => {
        setInfo(params);
        const unblockTime = Date.now() + RESEND_TIMEOUT;
        localStorage.setItem("blockUntil", unblockTime.toString());
        setIsDisabledBtn(true);
        setRemainingSeconds(RESEND_TIMEOUT / 1000);
        setStep(2);
      },
    });
  };

  const formatTime = (seconds: number) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min} мин. ${sec.toString().padStart(2, "0")} сек.`;
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
      <InputField
        control={control}
        name="email"
        label="Почта"
        className={styles.inputField}
        helperText={
          isDisabledBtn
            ? `Повторная отправка кода подтверждения будет доступна через ${formatTime(
                remainingSeconds
              )}`
            : ""
        }
        disabled
      />
      <Button
        type="submit"
        variant="contained"
        disabled={isDisabledBtn || !isValid}
        sx={saveBtnStyles}
      >
        Отправить код
      </Button>
      <Button
        variant="text"
        onClick={() => navigate("/personal-cab")}
        sx={backButtonStyles}
        type="button"
        startIcon={<ArrowBack />}
      >
        Вернуться
      </Button>
    </form>
  );
};
